import { useEffect } from "react";
import { useRoutes, useNavigate, Navigate } from "react-router-dom";
import LayoutDesign from "../Component/LayoutPage/LayoutPage";
import Tenants from "../Component/TenantsPage/tenants";
import Support from "../Component/SupportPage/Support";
import Login from "../AuthPages/Login";
import DashBoard from "../Component/DashBoard/DashBoard";
import Pricing from "../Component/Pricing/Pricing";
import Team from "../Component/TeamPage/Team";
import FaqPage from "../Component/Faq/faq";
import SalesPage from "../Component/SalesPage/Sales";
import SupportViewdetails from "../Component/SupportPage/SupportViewdetails";
import TenantDetails from "../Component/TenantsPage/tenantsDetails";
import BillingDashboard from "../Component/BillingDashboard/BillingDashboard";
import StripePlatformSettings from "../Component/StripePlatformSettings/StripePlatformSettings";
import PaymentMethodSettings from "../Component/PaymentMethodSettings/PaymentMethodSettings";
import NotificationAlertSettings from "../Component/NotificationAlertSettings/NotificationAlertSettings";
import Cookies from "js-cookie";
import ForgetPasswordPage from "../AuthPages/ForgetPassword";

export default function RoutePage() {
  const navigate = useNavigate();

  useEffect(() => {
    const token = Cookies.get("token");
    const path = window.location.pathname;
    const publicPaths = ["/login", "/forgot-password"];
    if (!token && !publicPaths.includes(path)) {
      navigate("/login", { replace: true });
    }
  }, [navigate]);

  let routes = useRoutes([
    {
      path: "/",
      element: <LayoutDesign />,

      children: [
        { index: true, element: <Navigate to="/dashboard" replace /> },
        { path: "/dashboard", element: <DashBoard /> },
        { path: "/tenants", element: <Tenants /> },
        { path: "/price", element: <Pricing /> },
        { path: "/support", element: <Support /> },
        { path: "/support-viewdetails/:id", element: <SupportViewdetails /> },
        { path: "/team", element: <Team /> },
        { path: "/faq", element: <FaqPage /> },
        { path: "/sales", element: <SalesPage /> },
        { path: "/tenant-details/:id", element: <TenantDetails /> },
        { path: "/billing", element: <BillingDashboard /> },
        { path: "/stripe-platform", element: <StripePlatformSettings /> },
        { path: "/payment-methods", element: <PaymentMethodSettings /> },
        { path: "/notification-alerts", element: <NotificationAlertSettings /> },
      ],
    },
    { path: "/login", element: <Login /> },
    { path: "/forgot-password", element: <ForgetPasswordPage /> },
  ]);
  return routes;
}
